import React from 'react';

import { cn } from '@/lib/utils';

import { commonStyles } from '@/components/atoms/card';
import LinkButton from '@/components/atoms/linkButton';
import { Text } from '@/components/atoms/text';

import { VideoPopup } from './videoPopUp';

//use after the component will be moved to decodo
// import { VideoPopup } from '@/decodo/components/atoms/videoPopup';
import IconHelpDocs from '~/svg/IconHelpDocs.svg';
import IconPlayButton from '~/svg/IconPlayButton.svg';

export const variantsOptions = ['none', 'outlined'] as const;

export const variantStyles: {
  [key in cardOptions]: string;
} = {
  outlined: `${commonStyles} rounded-3xl p-5 md:p-6 w-full md:w-[326px] border-neutral-N10 dark:border-neutral-dark-N80`,
  none: 'md:w-[326px] flex-col p-6 text-left w-full',
} as const;

export type cardOptions = (typeof variantsOptions)[number];

export interface ProductCardItemProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  description: React.ReactNode;
  button: React.ReactNode;
  videoLink: React.ReactNode;
  documentLink?: string;
  cardType: cardOptions;
}

export default function ProductCardItem({
  icon,
  title,
  subtitle,
  description,
  button,
  videoLink,
  documentLink,
  cardType,
}: ProductCardItemProps) {
  return (
    <div className={cn('h-full', variantStyles[cardType])}>
      <div className='flex h-full flex-col justify-between'>
        <div className='text-left'>
          <div className='pb-4'>{icon}</div>
          <div className='pb-3'>
            <Text variant={cardType === 'none' ? 'subtitle-m' : 'subtitle-l'}>
              {title}
            </Text>
            <Text variant={cardType === 'none' ? 'subtitle-m' : 'subtitle-l'}>
              {subtitle}
            </Text>
          </div>
          <Text
            color='neutral-N80'
            classNames={{
              wrapper: cn('dark:text-neutral-dark-N40', !!button && 'pb-6'),
            }}
          >
            {description}
          </Text>
        </div>
        {!!button && (
          <div className='flex h-10 items-center gap-6'>
            {!!button && (
              <div data-tracker-component='action-button'>{button}</div>
            )}
            {videoLink && (
              <VideoPopup
                renderVideo={(props) =>
                  React.cloneElement(videoLink as React.ReactElement, props)
                }
                icon={<IconPlayButton className='text-neutral-N99' />}
                // classNames={{
                //   root: 'p-1 w-8 !h-8 bg-transparent hover:bg-gray-200/40',
                // }}
                //will be needed after the component will be moved to decodo
              />
            )}
            {!!documentLink && (
              <LinkButton
                data-tracker-component='help-docs'
                variant='filled'
                href={documentLink}
                slim
                classNames={{
                  root: 'p-1 w-8 h-8 rounded-3xl bg-transparent hover:bg-neutral-N04 text-neutral-N99',
                }}
              >
                <IconHelpDocs className='w-6' />
              </LinkButton>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
